import { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
//import React, { useEffect, useState } from "react";
//import AdminLayout from "./AdminLayout";
import { endpoints } from "../_config";
import { get } from "../_services/apiService";
import { Link } from "react-router-dom";
import '../Dashboard.css';

const UserDashboard = () => {


    const loginId = localStorage.getItem("loginId");
    const [appointmentData, setAppointmentData] = useState([]);
    const [quatationData, setQuatationData] = useState([]);
    // const [clubMembership, setClubMembership] = useState([]);
    const [enquiryData, setEnquiryData] = useState([]);

    const GetBookAppoinment = async () => {
        try {
            const response = await get(endpoints.GetBookAppoinmentByLoginId + "?pLoginId=" + loginId)
    
            if (response.isSuccess === 200) {
                setAppointmentData(response.data);
            } else {
                setAppointmentData([]);
            }
        } catch (error) {
            setAppointmentData([]);
        } 
    };

    const GetQuatation = async () => {
        try {
            const response = await get(endpoints.GetQuatationByLoginId + "?pLoginId=" + loginId)
    
            if (response.isSuccess === 200) {
                setQuatationData(response.data);
            } else {
                setQuatationData([]);
            }
        } catch (error) {
            setQuatationData([]);
        }
    };

    // const GetClubMembership = async () => {
    //     try {
    //         const response = await get(endpoints.GetClubMembershipByLoginId + "?pLoginId=" + loginId)
    
    //         if (response.isSuccess === 200) {
    //             setClubMembership(response.data);
    //         } else {
    //             setQuatationData([]);
    //         }
    //     } catch (error) {
    //         setQuatationData([]);
    //     }
    // };

    const GetEnquiry = async () => {
        try {
            const response = await get(endpoints.GetEnquiryLoginId + "?pLoginId=" + loginId)
    
            if (response.isSuccess === 200) {
                setEnquiryData(response.data);
            } else {
                setEnquiryData([]);
            }
        } catch (error) {
            setEnquiryData([]);
        } 
    };

    useEffect(() => {
        GetQuatation();
        GetBookAppoinment();
        // GetClubMembership();
        GetEnquiry();
    }, []);

    return (

        <AdminLayout  >


            <div className="dashboard_add_quotation_wepper" style={{marginLeft:'328px'}}>
                <div className="row jus" >
                    <div className="col-3">
                        <Link to="/admin/userappointments">
                            <div className="shadow_box_wrapper pink_bg box_bg_high custom_box">
                                <span className="icon_wrapper"><i className="fa fa-calendar-alt"></i></span>
                                <span className="count_wrapper">{appointmentData?.length}</span>
                                <p className="mt-2">Appointments</p>
                            </div>
                        </Link>
                    </div>

                    <div className="col-3">
                        <Link to="/admin/userquotation">
                            <div className="shadow_box_wrapper yellow_bg box_bg_high custom_box">
                                <span className="icon_wrapper"><i className="fa fa-quote-left"></i></span>
                                <span className="count_wrapper">{quatationData?.length}</span>
                                <p className="mt-2">Quotes</p>
                            </div>
                        </Link>
                    </div>

                    <div className="col-3">
                        <Link to="/admin/userenquiry">
                            <div className="shadow_box_wrapper green_bg box_bg_high custom_box">
                                <span className="icon_wrapper"><i className="fa fa-users"></i></span>
                                <span className="count_wrapper">{enquiryData?.length}</span>
                                <p className="mt-2">Enquiry</p>
                            </div>
                        </Link>
                    </div>

                </div>
            </div>
        </AdminLayout>
    )
}

export default UserDashboard;